import axios from "../axiosConfig"; // Adjust the import path accordingly

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
// const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const CustomizeDeleteService = {

    DeleteTransactionsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/DeleteTransactionsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    ResetTransItemsAccountsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/ResetTransItemsAccountsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    DeleteItemsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/DeleteItemsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    DeleteItemGroupsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/DeleteItemGroupsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    DeleteAccountsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/DeleteAccountsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    DeleteAccountGroupsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/DeleteAccountGroupsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

    
    ResetTransItemsAccountsAsync: async (data) => {
        const apiUrl = `${WebApiUrl}/api/CustomizeDelete/ResetTransItemsAccountsAsync`;

        return await axios({
            method: "post",
            url: apiUrl,
            data: data,
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });
    },

};

export default CustomizeDeleteService;
